module.exports = __webpack_public_path__ + "static/6-0b8df1dcebe7ea880f6eb313e5f96ed3.jpeg";